(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-prima-guida"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-pg-variant]'))return;const root=event.target.closest('.pg');const option=event.target.selectedOptions[0];const available=option.dataset.available==='true';root.querySelector('[data-pg-price]').textContent=option.dataset.price;root.querySelector('[data-pg-buy]').disabled=!available;root.querySelector('[data-pg-available]').hidden=!available;root.querySelector('[data-pg-sold]').hidden=available;});

  } catch(e) { console.error(e); }
})();
})();
